export enum GuestRoles {
  GUEST = "Guest",
  PARENT_GUARDIAN = "Parent / Guardian",
}
